/**
 * @prettier
 * @flow
 */
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { navigate } from '@reach/router';
import React from 'react';
import { translate } from 'src/utils/translate/translate';

export function BackButton({ tooltip, onClick }: Props) {
    return (
        <Tooltip title={tooltip || translate('Back')}>
            <IconButton onClick={onClick ?? (() => navigate(-1))}>
                <ArrowBackIcon />
            </IconButton>
        </Tooltip>
    );
}

type Props = {
    tooltip?: string,
    onClick?: Function,
};
